import { getProviderBrick } from "./internal/data/getProviderBrick.js";
import { resolveByProvider } from "./internal/data/resolveData.js";
export async function fetchByProvider(provider, args, options) {
  const providerBrick = await getProviderBrick(provider);
  return resolveByProvider(providerBrick, provider, "resolve", args, options);
}
//# sourceMappingURL=fetchByProvider.js.map